// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-dashed.js';

import { paths } from '../generated/circle-dashed';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-dashed', Original, paths);
